import { booleanAttribute, Component, Input } from '@angular/core';
import { IconComponent, IconSize } from '../../icons/icon.component';
import { IconName } from '../../icons/icon-map';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-text-with-icon',
  imports: [IconComponent, MatTooltip, TranslatePipe],
  templateUrl: './text-with-icon.component.html',
  styleUrl: './text-with-icon.component.scss',
})
export class TextWithIconComponent {
  @Input() name?: IconName;
  @Input() size: IconSize = IconSize.MD;
  @Input({ transform: booleanAttribute }) vertical: boolean = false;
  @Input() hint?: { error: boolean; text: string };
}
